export const API_GET_ALL_TEMPLATE = "/api/v1/cafe/buscar/";